
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business-solutions/submission-success",
      function () {
        return require("private-next-pages/business-solutions/submission-success/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business-solutions/submission-success"])
      });
    }
  